import { render } from "./CreateView.vue?vue&type=template&id=236efa4d"
import script from "./CreateView.vue?vue&type=script&lang=js"
export * from "./CreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__